import React, { useEffect } from "react";
import { FaCalendarAlt, FaMapMarkerAlt, FaMoon } from "react-icons/fa";
import StarRating from "../StarRating/starrating";
import "./hotelOfferSaleHero.css";

/**
 * Presentational hero for public hotel offer — full-bleed image, gradient, centered RTL copy.
 */
export default function HotelOfferSaleHero({
  hotelName,
  heroImage,
  rating = 0,
  checkIn,
  checkOut,
  nights,
  destination,
  tags = [],
  onPrimaryCta,
  onUnmountCleanup,
}) {
  const ratingNum = Number(rating);
  const safeRating = Number.isFinite(ratingNum) ? Math.min(5, Math.max(0, ratingNum)) : 0;
  const nightsLabel =
    nights != null && nights !== ""
      ? `${nights} ${Number(nights) === 1 ? "לילה" : "לילות"}`
      : null;
  const datesLine =
    checkIn && checkOut ? `${checkIn} – ${checkOut}` : checkIn || checkOut || "";

  useEffect(() => {
    return () => {
      if (typeof window !== "undefined") {
        try {
          window.sessionStorage.removeItem("hotelOfferSnapshot");
        } catch {
          /* ignore */
        }
      }
      if (typeof onUnmountCleanup === "function") {
        onUnmountCleanup();
      }
      console.info("[PUBLIC_HOTEL_STATE_RESET]", {
        phase: "hotel_offer_sale_hero_unmount",
        component: "HotelOfferSaleHero",
      });
    };
  }, [onUnmountCleanup]);

  return (
    <header className="hotel-offer-hero" aria-label="פרטי המלון" dir="rtl">
      <div className="hotel-offer-hero__layers" aria-hidden={!!heroImage}>
        {heroImage ? (
          <img
            src={heroImage}
            alt=""
            className="hotel-offer-hero__img"
            loading="eager"
            decoding="async"
          />
        ) : (
          <div className="hotel-offer-hero__img hotel-offer-hero__img--placeholder" />
        )}
        <div className="hotel-offer-hero__scrim" aria-hidden />
      </div>
      <div className="hotel-offer-hero__content">
        <div className="hotel-offer-hero__inner">
          {typeof onPrimaryCta === "function" ? (
            <button
              type="button"
              className="hotel-offer-hero__floating-cta"
              onClick={onPrimaryCta}
            >
              הזמן עכשיו
            </button>
          ) : null}
          <h1 className="hotel-offer-hero__title">{hotelName || "הצעת מחיר למלון"}</h1>
          {safeRating > 0 ? (
            <div className="hotel-offer-hero__stars">
              <StarRating rating={safeRating} starSize={26} />
            </div>
          ) : null}
          <div className="hotel-offer-hero__meta-row">
            {datesLine ? (
              <span className="hotel-offer-hero__meta-chip">
                <FaCalendarAlt className="hotel-offer-hero__chip-icon" aria-hidden />
                {datesLine}
              </span>
            ) : null}
            {nightsLabel ? (
              <span className="hotel-offer-hero__meta-chip">
                <FaMoon className="hotel-offer-hero__chip-icon" aria-hidden />
                {nightsLabel}
              </span>
            ) : null}
          </div>
          {destination ? (
            <p className="hotel-offer-hero__destination">
              <FaMapMarkerAlt className="hotel-offer-hero__icon" aria-hidden />
              {destination}
            </p>
          ) : null}
          {Array.isArray(tags) && tags.length ? (
            <div className="hotel-offer-hero__tags" aria-label="תגיות הצעה">
              {tags.slice(0, 4).map((tag, index) => (
                <span key={`${tag}-${index}`} className="hotel-offer-hero__tag">
                  {tag}
                </span>
              ))}
            </div>
          ) : null}
        </div>
      </div>
    </header>
  );
}
